// extracted by mini-css-extract-plugin
export default {"container":"Conclusion_container__+3w6Z","Main":"Conclusion_Main__qr6Lo","Title":"Conclusion_Title__IvJoI","Content":"Conclusion_Content__kvxOS","Legal":"Conclusion_Legal__7llpg"};